<template>
  <button @click="emit('click')">
    <slot></slot>
  </button>
</template>
<script setup>
const emit = defineEmits(['click'])
</script>
<style scoped>
button {
  padding: 10px 20px;
  background-color: var(--base-color);
  color: #ffffff;
  border-radius: var(--base-border-radius);
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
}

button:hover {
  background-color: rgb(164, 74, 255);
}

button:disabled {
  background-color: #a463ff80;
  cursor: not-allowed;
}

.secondary {
  background-color: #ffffff;
  color: var(--base-color);
  outline: 2px solid var(--base-color);
  outline-offset: -2px;
}

.secondary:hover {
  background-color: var(--base-color);
  color: #ffffff;
}
</style>
